import React from 'react'

const RecordNotFound = () => {
  return (
    <div className='pv-recordnotfound-main d-flex align-items-center justify-content-center flex-column w-fitcontent m-auto my-4'>
      <img
        src='https://img.freepik.com/premium-vector/no-data-concept-illustration_86047-488.jpg?w=996'
        alt=''
        width='350px'
      />
      <h2>No records has been added yet.</h2>
      <p>Add new record by simply Clicking create button.</p>
    </div>
  )
}

export default RecordNotFound
